import { InternalNotification } from './notification';

export function createInfoNotification(message: string, showToast = true): InternalNotification {
	return {
		message,
		showToast,
		type: 'info',
		id: crypto.randomUUID(),
		timestamp: new Date(),
	};
}

export function createSuccessNotification(message: string, showToast = true): InternalNotification {
	return {
		message,
		showToast,
		type: 'success',
		id: crypto.randomUUID(),
		timestamp: new Date(),
	};
}

export function createWarningNotification(message: string, showToast = true): InternalNotification {
	return {
		message,
		showToast,
		type: 'warning',
		id: crypto.randomUUID(),
		timestamp: new Date(),
	};
}

export function createErrorNotification(message: string, showToast = true): InternalNotification {
	return {
		message,
		showToast,
		type: 'error',
		id: crypto.randomUUID(),
		timestamp: new Date(),
	};
}
